import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEthereum: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconEthereum"><Path d="M10.4275 13.6377L12 15.7998L13.5725 13.6377L12 14.0308L10.4275 13.6377Z" fill="currentColor"/><Path d="M12 11.9692L14.3194 11.3894L12 8.20018L9.68059 11.3894L12 11.9692Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM12 4.79982L6.7635 12L12 19.2002L17.2365 12L12 4.79982Z" fill="currentColor"/></CentralIconBase>;
});

export default IconEthereum;
